import { Component, OnInit } from '@angular/core';
import { AllPageService } from "src/app/shared/services/all-page.service";
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
declare  var jQuery:  any;
declare var site: any;

@Component({
  selector: 'app-vitality-blast',
  templateUrl: './vitality-blast.component.html',
  styleUrls: ['./vitality-blast.component.scss']
})
export class VitalityBlastComponent implements OnInit {
  contentRequest: any = {};
	contentList: any = {};
  // timerconfig: any = "";
  
  constructor(
    private allpagesService: AllPageService,
    private router: Router
  ) { }

  ngOnInit() {
    this.loadBannerbottom();
      // var enddate = new Date("2022-05-26 17:00:00");
      // var startdate = new Date();
      // console.log(startdate);
      // var seconds = (enddate.getTime() - startdate.getTime()) / 1000;
      // var days_diff = (enddate.getTime() - startdate.getTime()) / (1000 * 3600 * 24);
      // var newnum = days_diff.toFixed(0);
      // this.timerconfig = { leftTime: seconds, format: '<ul><li>'+newnum+'</li><li>H</li><li>m</li><li>s</li></ul>' };
 
  }
  loadBannerbottom() {
		this.contentRequest = {
			title: 'Vitality Blast'
		};
		let request = Object.assign({}, this.contentRequest);
		this.allpagesService.getContactText(request).then((data: any) => {
			this.contentList = data.data[0];
			console.log(this.contentList);
		});
	}
  calculateDiff(){
		let date = new Date('24/05/2022');
		let currentDate = new Date();
	
		let days = Math.floor((currentDate.getTime() - date.getTime()) / 1000 / 60 / 60 / 24);
		return days;
	}
  
}
